/*
 * Public API Surface of client-interaction-layout
 */
export {InboundModule} from './lib/inbound/inbound.module';
export {CbnModule} from './lib/cbn/cbn.module';
export {ChatModule} from './lib/chat/chat.module';
export {ChatPanelsModule} from './lib/chat-panels/chat-panels.module';
export {ClosePanelModule} from './lib/close-panel/close-panel.module';
export {DataCollectionModule} from './lib/data-collection/data-collection.module';
export {LoadingPanelModule} from './lib/loading-panel/loading-panel.module';
export {MessagesModule} from './lib/messages/messages.module';
export {MinimizedModule} from './lib/minimized/minimized.module';
export {MultimediaModule} from './lib/multimedia/multimedia.module';
export {QueueModule} from './lib/queue/queue.module';
export {TopBarModule} from './lib/top-bar/top-bar.module';

export {ChatComponent} from './lib/chat/chat/chat.component';
export {ChatAreaComponent} from './lib/chat/chat-area/chat-area.component';
export {TopBarComponent} from './lib/top-bar/top-bar/top-bar.component';
export {ChatIsWritingComponent} from './lib/chat/chat-is-writing/chat-is-writing.component';
